import { Row } from 'react-bootstrap';
import '../styles/components/info-modal-section.scss';
import AccordionContainer from './AccordionContainer';
import FormatTable from './FormatTable';

const TaxBalanceDescription = () => {
  return (
    <>
      <Row className="section">
        <h2>Overview</h2>
        <p className="text-start">Download Complete Tax Balance File</p>
        <p> Available approximately October 15</p>
        <p>
          Download a file of all serial numbers with a tax balance due. The file is updated daily at
          midnight.
        </p>
      </Row>
      <AccordionContainer id="taxBalanceAccordion">
        <FormatTable title="Tax Balance File" />
      </AccordionContainer>
    </>
  );
};

export default TaxBalanceDescription;
